import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Alert } from 'antd';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
const { ErrorBoundary } = Alert;

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
